<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
      <div style="font-size: 20px;">{{ storeName }}</div>
      <div style="height: 30px;"></div>

      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            店舗在庫及び基準在庫確認
          </v-card-title>          
          
          <!-- 달력 -->
          <v-layout row wrap align-center>
            <v-flex xs8 sm2>
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="shippingDate"
                    label="棚卸日"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="shippingDateForPicker"
                  @input="menu = false"
                  locale="jp-ja"
                  :day-format="shippingDate => new Date(shippingDate).getDate()"
                  no-title
                  @change="changeDate()"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <!-- 다운로드 버튼 -->
            <v-flex xs8 sm2 align-self-center>
              <v-btn block color="primary" dark @click="downloadCsv()">
                <v-icon dark left>get_app</v-icon>{{ $t('download-btn') }}
              </v-btn>
            </v-flex>
          </v-layout>

          <div style="height: 20px; text-align-last: start;">※基準在庫、物理在庫数の修正は現在日付のみ可能です</div>
          <div style="height: 30px;"></div>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="商品名検索"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              :headers="headers"
              :items="storeItems"
              hide-actions
              class="elevation-1"
              style="width: 100%;    margin: 15px 0 0;"
              :search="search"
              :customFilter="customFilter"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left px-2">{{ props.item.itemCategoryName }}</td>
                  <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                  <td class="text-xs-center px-2">{{ props.item.janCode }}</td>

                  <!--store-realtime-stocktaking 에서 가져온다다-->
                  <td class="text-xs-left px-2" v-if="isNow">{{ props.item.updatedAt }}</td>

                   <!--store-stocktaking-history 에서 가져온다다-->
                  <td class="text-xs-left px-2" v-else>{{ props.item.createdAt }}</td>

                  <td class="text-xs-right px-2" v-if="isNow">
                    <input type="number" categoryName="itemNum[]" v-model="props.item.stockQuantity" min="0" class="column-input" 
                      style="width: 100% !important;" @change="editItem(props.item)" />
                  </td>
                  <td class="text-xs-right px-2" v-else>{{ props.item.stockQuantity }}</td>

                  <td class="text-xs-right px-2" v-if="isAutoOrder === '1' && isNow === true" >
                    <input type="number" categoryName="itemNum[]" v-model="props.item.standardStock" min="0" class="column-input" 
                      style="width: 100% !important;" @change="editItem(props.item)" />
                  </td>
                  <td class="text-xs-right px-2" v-else>{{ props.item.standardStock }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 25px;"></div>
      
      <v-layout row wrap>
        <v-flex xs12 sm12 v-if="storeItems.length > 0 && isAutoOrder === '1' && isNow == true">
          <v-btn  
            block
            color="warning"
            dark
            @click="updateStandardStock()"
          >確定する</v-btn>
        </v-flex>

        <div style="height: 25px;"></div>

        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/store-standard-stock-management' }">
            <v-icon dark left>arrow_back</v-icon>
            {{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import moment from 'moment-timezone'
import { mapState } from 'vuex'
import axios from 'axios'
import ServerApiCallService from '@/services/ServerApiCallService.js'

export default {
  created() {
    console.log('created')
    
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.storeCode = this.$route.params.storeCode
    this.storeName = this.$route.params.storeName    
    this.shippingDate = moment().format('YYYY/MM/DD')
    this.isNow = true;

    // 점포 정보 가져오기
    this.getStore()
    // 점포의 상품정보 가져오기
    this.getStandardStock()
  },
  methods: {
    customFilter(items, search) {
      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemName.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getStore() {
      let request = {storeCode: this.storeCode}
      ServerApiCallService.store(request)
        .then(response => {
          this.isAutoOrder = response.data.store.isAutoOrder
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    getStandardStock() {
      console.log("getStandardStock");

      let now = moment().format('YYYY/MM/DD')

      if (this.shippingDate == '') {
        this.shippingDate = now
      }      
      
      if (now != this.shippingDate) {
        this.isNow = false
      } else {
        this.isNow = true
      }

      let request = {storeCode: this.storeCode, createdAt: this.shippingDate.replace(/\//g, '')}
      ServerApiCallService.getStandardStock(request)
        .then(response => {
          this.storeItems = response.data.storeItems

          // カテゴリの表示順
          this.storeItems.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })
          
          // 데이타 변형
          this.storeItems.forEach(function(row) {            
            // 생성날짜는 초까지 보이기
            if (row.createdAt != null) {
              row.createdAt = row.createdAt.substr(0, 16)
            }
            // 변경날짜는 초까지 보이기
            if (row.updatedAt != null) {
              row.updatedAt = row.updatedAt.substr(0, 16)
            }
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    editItem(item) {
      // 중복된 상품은 제외하고 업데이트 한다(두번 클릭할 경우)
      let bol = false;
      if (this.editedItem.length > 0) {
        for (let i=0; i<this.editedItem.length; i++) {
          if (this.editedItem[i].itemCode == item.itemCode) {
            this.editedItem[i].stockQuantity = item.stockQuantity
            this.editedItem[i].standardStock = item.standardStock
            bol = true;
          }
        }
        // 상품이 등록되어 있지 않은 경우
        if (!bol) {
          this.editedItem.push(item);
        }
      } else {
        // 처음 상품을 등록할 경우
        this.editedItem.push(item);
      }      
    },
    updateStandardStock() {

      if(this.editedItem.length < 1) {
        alert("在庫または基準在庫のデータを入力してください")
        return false;
      }

      let request=[];      
      for (let i=0; i<this.editedItem.length; i++) {

        if (this.editedItem[i].standardStock == null) {
          this.editedItem[i].standardStock = 0;
          this.editedItem[i].stockQuantity = 0;
        }
        
        let obj = {
          storeCode: this.storeCode,
          itemCode: this.editedItem[i].itemCode,
          standardStock: this.editedItem[i].standardStock,
          stockQuantity: this.editedItem[i].stockQuantity
        }
        
        request.push(obj);
      }

      ServerApiCallService.updateStandardStock(request)
        .then(response => {
          // 초기화
          this.editedItem = []
          
          ServerApiCallService.getStandardStock({storeCode: this.storeCode})
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    changeDate() {
      this.shippingDate = this.shippingDateForPicker.replace(/-/g, '/')
      this.getStandardStock()
    },  
    downloadCsv() {
      let request = {storeCode: this.storeCode, createdAt: this.shippingDate.replace(/\//g, '')}

      axios
      .create({
        baseURL: ServerApiCallService.getServerUrl(),
        withCredentials: false,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=utf-8',
          accessToken: window.localStorage.getItem('accessToken')
        }
      })
      .post('/admin/store-stocktaking-download', request, {
        responseType: 'blob',
      })
      .then(({ data }) => {
        let blob = new Blob([data], { type: 'text/csv' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = this.storeCode + '_店舗在庫一覧.csv'
        link.click()
      })
    },
  },
  computed: {
    shippingDate: {
      get() {
        let shippingDate = this.$store.state.adminSession
          .orderConfirmSelectedShippingDate
        if (shippingDate == null) {
          return moment().format('YYYY/MM/DD')
        }
        return shippingDate
      },
      set(value) {
        this.$store.commit('SET_ORDER_CONFIRM_SELECTED_SHIPPING_DATE', value)
      }
    }    
  },
  data() {
    return {
      menu: false,
      editedItem: [],
      editedStockQuantity: [],
      warehouses: [],
      loading: false,
      dispWarehouseItems: false,
      selectedWarehouse: [],
      search: '',
      storeItems: [],
      isAutoOrder: '0',
      isNow: false,      
      shippingDateForPicker: '',
      headers: [
        {
          text: 'Category name',
          align: 'left',
          value: 'itemCategoryName',
          width: '15%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          width: '20%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        }, 
        {
          text: 'JANコード',
          align: 'center',
          value: 'janCode',
          width: '30%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },             
        {
          text: this.$t('sales.updated-at'),
          align: 'left',
          value: 'updatedAt',
          width: '15%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.stock-quantity'),
          align: 'left',
          value: 'stockQuantity',
          width: '10%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.standard-stock'),
          align: 'right',
          sortable: false,
          value: 'stocks',
          width: '10%',
          fixed: true,
          class: 'px-2'
        }
      ]
    }
  }
}
</script>

<style>
.confirmed-items {
  background-color: #adadad;
}
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}
.column-input-for-realtime-stock {
  width: 75px !important;
  height: 40px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
  font-size: 13px;
}
.deleted-class-name {
  background-color: #b3b3b3;
}
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ffcccc;
}
.out-stock-class-name {
  background-color: #ed2939;
}
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
</style>
